import { colors, fontSize } from '../../constants/styleConstants';

export const style = theme => ({
  root: {
    width: '100%',
    minWidth: 150,
    height: 36,
    background: colors.white,

    '& .MuiInputBase-root': {
      height: 35,
      padding: '0px 0px 0px 8px',
    },

    '& .MuiAutocomplete-hasClearIcon': {
      paddingRight: '14 !important',
    },

    '& .MuiAutocomplete-input': {
      paddingLeft: 8,
      fontSize: fontSize.medium,

      [theme.breakpoints.down('md')]: {
        fontSize: fontSize.basic,
        paddingLeft: 8,
      },
    },

    '& .MuiInputLabel-outlined': {
      transform: 'translate(14px, 7px) scale(1)',
      height: 24,
      margin: '0 48px 0 0',
      fontFamily: 'Roboto',
      fontSize: fontSize.medium,
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.71',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 'calc(100% - 20px)',
    },

    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, -10px) scale(0.8)',
      height: 16,
      lineHeight: '1.33',
      color: colors.grey4,
    },

    '& .MuiInputLabel-outlined.MuiInputLabel-shrink.MuiFormLabel-filled': {
      color: colors.grey4,
    },

    '& :hover .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      color: colors.darkBlue,
    },

    '& .MuiInputLabel-outlined.MuiInputLabel-shrink.Mui-focused': {
      color: colors.darkBlue,
    },

    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.darkBlue,
    },

    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.darkBlue,
    },

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.fieldsBorderGray,
    },
  },
  clearIndicator: {
    marginRight: 10,
    padding: 0,
    fontSize: fontSize.eleven,
  },
  popperDesktop: {
    zIndex: 998,
  },
  popper: {
    '& .MuiAutocomplete-paper': {
      fontSize: fontSize.medium,
      marginTop: '0 !important',
    },
  },
  inputRoot: {
    '&[class*="MuiOutlinedInput-root"]': {
      /* '$hasPopupIcon &, $hasClearIcon &': {
        paddingRight: 10,
      }, */

      '& .MuiAutocomplete-endAdornment': {
        right: 0,
        top: 'calc(50% - 12px)',
      },
    },

    '&[class*="MuiFilledInput-root"]': {
      '& .MuiAutocomplete-endAdornment': {
        right: 0,
        top: 'calc(50% - 12px)',
      },
    },
  },
  option: {
    '&.Mui-focused': {
      backgroundColor: colors.blue1,
    },

    '&[aria-selected="true"]': {
      backgroundColor: colors.blue1,
    },

    '&:active': {
      backgroundColor: colors.blue2,
    },
  },
});
